import { getVisualAssetDefinition } from '../visualAssets/catalog';

export interface MapObjectVisualDefinition {
  readonly id: string;
  readonly label: string;
  readonly imagePath: string;
  readonly width?: number;
  readonly height?: number;
  readonly drawScale: number;
  readonly yOffsetTiles: number;
  readonly animated: boolean;
}

const warnedMissingMapObjectVisuals = new Set<string>();
const warnedMapObjectImageFailures = new Set<string>();

function warnMissingMapObjectVisual(id: string): void {
  if (warnedMissingMapObjectVisuals.has(id)) {
    return;
  }
  warnedMissingMapObjectVisuals.add(id);
  console.warn(`[MapObjects] Missing visual asset definition for '${id}'. Skipping render.`);
}

export function reportMapObjectImageLoadFailure(id: string, imagePath: string): void {
  const key = `${id}:${imagePath}`;
  if (warnedMapObjectImageFailures.has(key)) {
    return;
  }
  warnedMapObjectImageFailures.add(key);
  console.warn(`[MapObjects] Failed to load image for '${id}' from '${imagePath}'. Skipping render.`);
}

export function getMapObjectVisualDefinition(id: string): MapObjectVisualDefinition | null {
  const definition = getVisualAssetDefinition(id);
  if (!definition) {
    warnMissingMapObjectVisual(id);
    return null;
  }
  return definition;
}
